<template>
  <div class="main-box">
    <el-form class="form-inline" :inline="true">
      <el-form-item label="名称">
        <el-input v-model="search.keywords" placeholder="请输入名称" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="handleSearch()">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="mg-bt-10">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addGroup()">添加</el-button>
      <el-button type="danger" size="small" icon="el-icon-delete" @click="delGroup()">删除</el-button>
    </div>
    <el-table
          :data="tableData"
          ref="rfTable"
          border
          style="width: 100%"
          size="mini"
          @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          align="center"
          width="55">
      </el-table-column>
      <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="100">
      </el-table-column>
      <el-table-column
          prop="title"
          label="商户名称"
          min-width="180">
      </el-table-column>
      <el-table-column
          prop="shop_name"
          label="店铺名称"
          min-width="180">
      </el-table-column>
      <el-table-column
          prop="username"
          label="登录账号"
          min-width="180">
        <template slot-scope="scope">
          {{ scope.row.username }} ({{ scope.row.nickname }})
        </template>
      </el-table-column>
      <el-table-column
          prop="version_str"
          label="版本"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="contact_name"
          label="联系人"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="contact_mobile"
          label="联系手机"
          align="center"
          width="160">
      </el-table-column>
      <el-table-column
          prop="home_recommend_status"
          label="审核状态"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-switch :value="scope.row.status==1" @change="statusGroup(scope.row.id,scope.row.status==1?0:1)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="ftime"
          label="添加时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          prop="over_time"
          label="到期时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editGroup(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="renewGroup(scope.row)"><span class="red">续费</span></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 30, 40]"
      :total="search.total">
    </el-pagination>
    <el-dialog title="账号续费" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" custom-class="dialog" width="740px">
        <el-select v-model="chooseYear" placeholder="请选择续费时间" class="mg-rt-20">
          <el-option
              v-for="item in yearList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="renewSure">续费</el-button>
    </el-dialog>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      info: false,
      yearList: [],
      dialogFormVisible: false,
      source_domain: this.config.SOURCE_DOMAIN,
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        keywords: ''
      },
      tableData: [],
      chooseYear: '',
      chooseItem: false
    };
  },
  created() {
    this.yearList = this.$configure.yearList;
    this.getList();
  },
  mounted() {
    //
  },
  computed: {
  },
  methods: {
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords
      }
      this.$api.merchant.merchantIndex(param, function (res) {
        that.hideLoading()
        if(res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    addGroup() {
      this.$router.push({name: 'user_merchant_add'})
    },
    editGroup(item) {
      this.$router.push({name: 'user_merchant_add', query: {id: item.id}})
    },
    renewGroup(item) {
      this.chooseItem = item
      this.chooseYear = ''
      this.dialogFormVisible = true
    },
    renewSure() {
      if(!this.chooseYear) {
        this.fail('请选择续费年限')
        return false
      }
      this.$api.merchant.merchantRenew({id: this.chooseItem.id, year: this.chooseYear},res => {
        if(res.errcode == 0) {
          this.dialogFormVisible = false
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    statusGroup(id,status) {
      this.$api.merchant.merchantShenhe({id: id, status: status},res => {
        if(res.errcode == 0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    delGroup() {
      var that = this
      var sel = this.$refs.rfTable.selection
      if(sel.length<1) {
        that.tips('请选择删除项')
        return false
      }
      var ids = []
      sel.forEach(function (item) {
        ids.push(item.id)
      })
      this.$confirm('确认要删除这些数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.merchant.merchantDelete({ids: ids},function (res) {
          if(res.errcode == 0) {
            that.success('删除成功')
            that.getList()
          } else {
            that.fail(res.errmsg)
          }
        })
      }).catch(() => {

      });
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
